module.exports = __webpack_public_path__ + "static/media/safety-Insights-landing-page.2b9821e5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/callouts/safety-Insights-landing-page.jpg
// module id = 1159
// module chunks = 0